import './styles.scss'
import PropTypes from 'prop-types'

const Button = (props) => {
  let classes = ['Button', 'Button-' + props.align]

  if (props.classNames !== '') {
    classes.push(props.classNames)
  }

  if (props.disabled === true) {
    classes.push('Button-Disabled')
  }

  return (
    <button
      type={props.type}
      style={props.style}
      className={classes.join(' ')}
      onClick={props.onClick}>{props.children}
    </button>
  )
}

Button.defaultProps = {
  onClick: () => {},
  disabled: false,
  type: 'button',
  classNames: '',
  align: 'left',
}

Button.propTypes = {
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['submit', 'reset', 'button', undefined]),
  align: PropTypes.string,
  classNames: PropTypes.string,
  style: PropTypes.object,
}

export default Button
